module.exports = __webpack_public_path__ + "img/web3.f8ce5b7e.png";